export default __webpack_public_path__ + "static/char-45-fee62e5bc8f8ecc5080fb4b3fabf9a43.webp";